import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntDaySelectorComponent} from "./int-day-selector.component";
import {DateControllerModule} from "../../directives";
import {IntCalendarCellModule} from "../cell";

@NgModule({
  imports: [
    CommonModule,
    DateControllerModule,
    IntCalendarCellModule
  ],
  declarations: [
    IntDaySelectorComponent
  ],
  exports: [
    IntDaySelectorComponent
  ]
})
export class IntDaySelectorModule {}
